import { render } from "./fantuimod.vue?vue&type=template&id=6174cdd1&scoped=true"
import script from "./fantuimod.vue?vue&type=script&lang=js"
export * from "./fantuimod.vue?vue&type=script&lang=js"

import "./fantuimod.vue?vue&type=style&index=0&id=6174cdd1&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\pros\\ydxc-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6174cdd1"]])

export default __exports__